var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5H4C2.6215 5 1.5 6.1215 1.5 7.5V17.5C1.5 18.8785 2.6215 20 4 20H20C21.3785 20 22.5 18.8785 22.5 17.5V7.5C22.5 6.1215 21.3785 5 20 5Z",
    fill: "#F7A46C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6C14.7235 6 14.5 5.7765 14.5 5.5V4C14.5 3.724 14.276 3.5 14 3.5H10C9.724 3.5 9.5 3.724 9.5 4V5.5C9.5 5.7765 9.2765 6 9 6C8.7235 6 8.5 5.7765 8.5 5.5V4C8.5 3.173 9.173 2.5 10 2.5H14C14.827 2.5 15.5 3.173 15.5 4V5.5C15.5 5.7765 15.2765 6 15 6Z",
    fill: "#2B384C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12H17C16.4485 12 16 11.5515 16 11V10.5H8V11C8 11.5515 7.5515 12 7 12H5.5C4.9485 12 4.5 11.5515 4.5 11V10.5H1.5C1.2235 10.5 1 10.2765 1 10C1 9.7235 1.2235 9.5 1.5 9.5H5C5.2765 9.5 5.5 9.7235 5.5 10V11H7V10C7 9.7235 7.2235 9.5 7.5 9.5H16.5C16.7765 9.5 17 9.7235 17 10V11H18.5V10C18.5 9.7235 18.7235 9.5 19 9.5H22.5C22.7765 9.5 23 9.7235 23 10C23 10.2765 22.7765 10.5 22.5 10.5H19.5V11C19.5 11.5515 19.0515 12 18.5 12Z",
    fill: "#2B384C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitimg);
export default __webpack_public_path__ + "static/media/kitimg.1385024387ad5368c34674606d8e8594.svg";
export { ForwardRef as ReactComponent };